import { useEffect, useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useAlert } from 'react-alert'

import {
  TypeToAvaliacaoModel,
  TypeToDocumentsModel
} from '../../../../domain/models'
import {
  fetchTypeToDocument,
  fetchTypeToService
} from '../../../../main/usecases'

import { goToUrl } from '../../../utils'
import { useModalBox } from '../../../contexts'
import { Button, SelectInput } from '../../../components'

import * as S from './styles'

export type DocumentsDataProps = {
  typeToService: number
  typeToDocument: number
}

const FilterCustomDocumentModal = () => {
  const [loading, setLoading] = useState(false)
  const [typeToDocument, setTypeToDocument] = useState<TypeToDocumentsModel[]>()
  const [typeToService, setTypeToService] = useState<TypeToAvaliacaoModel[]>()
  const [documentsData, setDocumentsData] = useState<DocumentsDataProps>(
    {} as DocumentsDataProps
  )
  const { modalClose } = useModalBox()
  const alert = useAlert()
  const history = useHistory()

  const optionsListDocuments = useMemo(
    () =>
      typeToDocument?.map((item) => {
        return {
          value: item?.cdTipoDocumentoPsicologico,
          label: item?.descricao
        }
      }),
    [typeToDocument]
  )

  const optionsListServices = useMemo(
    () =>
      typeToService?.map((item) => {
        return { value: item?.cdTipoAvaliacao, label: item?.tipoAvaliacao }
      }),
    [typeToService]
  )

  const handleFilterCustomDocument = async (
    typeToDocument?: TypeToDocumentsModel,
    typeToService?: TypeToAvaliacaoModel
  ) => {
    try {
      setLoading(true)

      goToUrl(history, `/documento`, {
        cdTypeToDocument:
          typeToDocument && typeToDocument.cdTipoDocumentoPsicologico,
        cdTypeToService: typeToService && typeToService.cdTipoAvaliacao,
        documentTitle: typeToDocument && typeToDocument.descricao,
        serviceTitle: typeToService && typeToService.tipoAvaliacao
      })

      modalClose(true)
    } catch (error) {
      console.error(error)
      alert.show('Erro ao filtrar modelo personalizado', {
        type: 'error',
        timeout: 4000
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    ;(async () => {
      try {
        const dataToTypeToDocuments = await fetchTypeToDocument().load()
        const dataToTypeToServices = await fetchTypeToService().load()

        setTypeToDocument(dataToTypeToDocuments)
        setTypeToService(dataToTypeToServices)
        setDocumentsData({
          typeToDocument: dataToTypeToDocuments[0].cdTipoDocumentoPsicologico,
          typeToService: dataToTypeToServices[0].cdTipoAvaliacao
        })
      } catch (error) {
        console.error(error)
      }
    })()
  }, [])

  return (
    <S.ModalInfo>
      <SelectInput
        labelColor="#4F4F4F"
        label="Tipo do documento*"
        name="typeToDocument"
        onChange={(e: any) =>
          setDocumentsData((prev: any) => ({
            ...prev,
            typeToDocument: Number(e.target.value)
          }))
        }
        value={documentsData?.typeToDocument}
        options={optionsListDocuments}
      />
      <SelectInput
        labelColor="#4F4F4F"
        label="Tipo do avaliação*"
        name="typeToService"
        onChange={(e: any) =>
          setDocumentsData((prev: any) => ({
            ...prev,
            typeToService: Number(e.target.value)
          }))
        }
        value={documentsData?.typeToService}
        options={optionsListServices}
      />
      <Button
        disabled={loading}
        onClick={() =>
          handleFilterCustomDocument(
            typeToDocument?.find(
              (item) =>
                item.cdTipoDocumentoPsicologico === documentsData.typeToDocument
            ),
            typeToService?.find(
              (item) => item.cdTipoAvaliacao === documentsData.typeToService
            )
          )
        }
      >
        Filtrar
      </Button>
    </S.ModalInfo>
  )
}

export default FilterCustomDocumentModal
